import { loadNativeModule, pickMethod, describeError } from './loadNativeModule';

// Shared across getWifiStatus/getEthernetLink so the module loads once per run.
// Scoped to a single run via resetNetworkStatusCache() — a re-run must rebuild to
// read live state, not the previous run's cached readings.
let cachedInstance = null;

export function resetNetworkStatusCache () {
    cachedInstance = null;
}

function getNetworkStatusInstance () {
    if (cachedInstance) return cachedInstance;
    const NetworkStatus = loadNativeModule('@brightsign/networkstatus');
    if (!NetworkStatus) return null;
    cachedInstance = new NetworkStatus();
    return cachedInstance;
}

export async function getWifiStatus (iface = 'wlan0') {
    const instance = getNetworkStatusInstance();
    if (!instance) return { available: false, reason: 'networkstatus module unavailable' };

    try {
        const getWifiInterfaceStatus = pickMethod(instance, ['getInterfaceWifiStatus', 'getinterfacewifistatus']);
        if (!getWifiInterfaceStatus) {
            return { available: false, reason: 'networkstatus getters unavailable on this firmware' };
        }

        const status = await getWifiInterfaceStatus(iface);
        return {
            available: true,
            connected: Boolean(status && status.connected),
            signalStrength: status && typeof status.signalStrength === 'number' ? status.signalStrength : null,
            essid: (status && status.essid) || null
        };
    } catch (error) {
        return { available: false, reason: `networkstatus threw: ${describeError(error)}` };
    }
}

export async function getEthernetLink (iface = 'eth0') {
    const instance = getNetworkStatusInstance();
    if (!instance) return { available: false, reason: 'networkstatus module unavailable' };

    try {
        const getInterfaceStatus = pickMethod(instance, ['getInterfaceStatus', 'getinterfacestatus']);
        if (!getInterfaceStatus) {
            return { available: false, reason: 'networkstatus getters unavailable on this firmware' };
        }

        const status = await getInterfaceStatus(iface);
        return {
            available: true,
            hasLink: Boolean(status && status.ipAddressList && status.ipAddressList.length)
        };
    } catch (error) {
        return { available: false, reason: `networkstatus threw: ${describeError(error)}` };
    }
}
